import { render, staticRenderFns } from "./__UserModal.vue?vue&type=template&id=72b91a77&"
import script from "./__UserModal.vue?vue&type=script&lang=js&"
export * from "./__UserModal.vue?vue&type=script&lang=js&"
import style0 from "./__UserModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports